import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import { setBreadcrumbs } from 'slices/config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_TYPING_ASSESSMENT_TEST_RESULT';
export const single = 'SINGLE_TYPING_ASSESSMENT_TEST_RESULT';

export const typingAssessmentTestResultsApi = createApi({
  reducerPath: 'typingAssessmentTestResultsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createTypingAssessmentTestResult: builder.mutation({
      query: (body) => ({
        url: '/typing-assessment-test-results/create',
        method: 'POST',
        body: body
      }),
      invalidatesTags: [list]
    }),
    submitTypingAssessmentTestResult: builder.mutation({
      query: ({ id, ...attributes }) => ({
        url: `/typing-assessment-test-results/submit/${id}`,
        method: 'PUT',
        body: { ...attributes }
      }),
      invalidatesTags: [single]
    }),
    getTypingAssessmentTestResultById: builder.query({
      query: ({ id, archived }) => ({ url: `/typing-assessment-test-results/view/${id}`, ...(archived && { params: { archived: 1 } }) }),
      providesTags: [single],
      async onQueryStarted(_, { dispatch, getState, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (getState().auth?.isLoggedIn && data?.data?.status === 'evaluated') {
            dispatch(setBreadcrumbs(`${data?.data?.email}/${data?.data?.referenceName ?? 'N/A'}`));
          }
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    unarchiveTypingAssessmentTestResult: builder.mutation({
      query: (ids) => ({
        url: `/typing-assessment-test-results/unarchive`,
        method: 'POST',
        body: {
          ids
        }
      }),
      async onQueryStarted(ids, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            typingAssessmentTestResultsApi.util.updateQueryData('listTypingAssessmentTestResults', undefined, (draft) => {
              draft.data.items = draft.data.items.filter((item) => !ids.includes(item.id));
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    listTypingAssessmentTestResults: builder.query({
      query: (params) => ({
        url: '/typing-assessment-test-results/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    }),
    exportTypingAssessmentTestResults: builder.query({
      query: (params) => ({
        url: '/typing-assessment-test-results/export',
        params: { ...params },
        responseHandler: (response) => response.text()
      })
    })
  })
});

export const {
  useCreateTypingAssessmentTestResultMutation,
  useSubmitTypingAssessmentTestResultMutation,
  useUnarchiveTypingAssessmentTestResultMutation,
  useGetTypingAssessmentTestResultByIdQuery,
  useListTypingAssessmentTestResultsQuery,
  useExportTypingAssessmentTestResultsQuery,
  useLazyExportTypingAssessmentTestResultsQuery
} = typingAssessmentTestResultsApi;
